import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"
import { McpActivityList } from "./mcp-activity-list"

export function McpActivityPage() {
	return (
		<>
			<MetaInfo title="Tool call history" />

			<div className="space-y-4">
				<SettingsHeader
					title="Tool call history"
					subtitle="Every tool the agent called, with its arguments. Kept 14 days."
				/>
				<McpActivityList />
			</div>
		</>
	)
}
